import PromotionalPackageDefaultCopy from '../../translations/promotionalPackageDefaultCopy'
import {AdditionalPromoText} from '../../types/singleModelInterface'

export interface AdditionalPromoCopy {
    title: string
    firstDetail: string
    secondDetail: string
    thirdDetail: string
}

const DEFAULT_TEXT: AdditionalPromoCopy = {
    title: PromotionalPackageDefaultCopy.TITLE,
    firstDetail: PromotionalPackageDefaultCopy.CUSTOM_INSTALLMENT,
    secondDetail: PromotionalPackageDefaultCopy.EXTENDED_WARRANTY,
    thirdDetail: PromotionalPackageDefaultCopy.REPLACEMENT,
}

export {DEFAULT_TEXT}

export default function getAdditionalPromoText(
    promotion?: Partial<AdditionalPromoText> | null
): AdditionalPromoCopy {
    if (typeof promotion === 'undefined' || !promotion) {
        return DEFAULT_TEXT
    }

    const promoTitle = promotion.additional_promotion_title
    const promoFirstDetail = promotion.additional_promotion_detail_1
    const promoSecondDetail = promotion.additional_promotion_detail_2
    const promoThirdDetail = promotion.additional_promotion_detail_3

    return {
        title: promoTitle ? promoTitle : PromotionalPackageDefaultCopy.TITLE,
        firstDetail: promoFirstDetail
            ? promoFirstDetail
            : PromotionalPackageDefaultCopy.CUSTOM_INSTALLMENT,
        secondDetail: promoSecondDetail
            ? promoSecondDetail
            : PromotionalPackageDefaultCopy.EXTENDED_WARRANTY,
        thirdDetail: promoThirdDetail
            ? promoThirdDetail
            : PromotionalPackageDefaultCopy.REPLACEMENT,
    }
}
